import { useEffect, useState } from "react";

import { TableUtil } from "@tyrannosaurustech/ui";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux";
import { setSort } from "../../../../redux/reducers/filter";
import { useGetRequests } from "../../../../redux/reduxQuery/requestApi";

export const useGetData = (initialQs = "") => {
  const [dataToFetch, setDataToFetch] = useState(initialQs);

  useEffect(() => {
    setDataToFetch((prev) => (prev === initialQs ? prev : initialQs));
  }, [initialQs]);
  const pageSize = useAppSelector(
    (state) => state.filter?.requestControl?.pageSize
  );
  const searchParam = useAppSelector(
    (state) => state.filter?.requestControl?.searchParam
  );
  const sort = useAppSelector((state) => state.filter?.requestControl?.sort);

  const getData = useGetRequests(dataToFetch);
  const useAsyncConfig = TableUtil.useAsyncConfig;
  let search: string | undefined = "";
  if (searchParam === undefined || typeof searchParam === "string") {
    search = searchParam;
  } else {
    search = "";
  }

  let [config, refetch] = useAsyncConfig(
    getData,
    Number(pageSize ?? 50),
    search
  );

  useEffect(() => {
    refetch();
  }, [dataToFetch]);

  const dispatch = useAppDispatch();

  console.log(config?.asyncConfig?.sort);

  // if there's a sort order in the redux store, let's use it
  // otherwise, let's default to submitted date ascending
  useEffect(() => {
    if ((sort as any)?.length > 0) {
      config.asyncConfig.onSortingChange(sort);
    } else {
      config.asyncConfig.onSortingChange([
        { id: "submittedDate", desc: false },
      ]);
    }
  }, []);

  // // let's save the sort order in the redux store
  useEffect(() => {
    dispatch(
      setSort({
        requestControl: {
          sort:
            config?.asyncConfig?.sort?.length > 0
              ? config?.asyncConfig?.sort
              : null,
        },
      })
    );
  }, [config?.asyncConfig?.sort, dispatch]);

  return {
    config,
    refetch,
    dataToFetch,
    setDataToFetch,
  };
};
